import { Observable } from 'rxjs/Observable';
import { AppSettings } from './../../../shared/app-settings';
import { AuthService } from './../../../auth/auth.service';
import { SecurityService } from './../../security.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginRegisterTabs } from 'app/security/security/login-and-register/loginRegisterTabs.enum';
import { DialogService } from 'app/shared/services/dialog-service';
import { EnrollmentProgramsService } from 'app/shared/services/enrollment-programs.service';
import { ProgramStatementsModel } from 'app/shared/models/program-statements.model';
import { BaseFormValidation } from './../../../shared/validators/base-form-validation';
import { CustomValidators } from './../../../shared/validators/custom-validators';
import { ActiveProviderModel } from 'app/shared/models/active-provider.model';


@Component({
  selector: 'online-app-login-and-register',
  templateUrl: './login-and-register.component.html',
  styleUrls: ['./login-and-register.component.scss']
})
export class LoginAndRegisterComponent extends BaseFormValidation implements OnInit {

  protected selectedTab: number = LoginRegisterTabs.Login;
  protected activeProviders: ActiveProviderModel[] = [];

  private statements:ProgramStatementsModel=new ProgramStatementsModel(null,null,null,null,null,null,null,null,null,true);
  private _enrollmentType: string;

  public get IsReferralCodeRequired():Observable<boolean>{
    return this.programsService.getIsReferralCodeRequired();
  }
  public get IsRestricted():Observable<boolean>{
    return this.programsService.getIsRestricted();
  }

  get enrollmentType() {
    return this._enrollmentType;
  }

  protected loginForm: FormGroup;

  protected registerForm: FormGroup;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private programsService:EnrollmentProgramsService,
    private dialogSer: DialogService,
    private fb: FormBuilder,
    private _service: SecurityService) 
  {
      
      super();


      //this.getActiveProviders();
      this.activatedRoute.params.subscribe(params => {
        this._enrollmentType = params['type'];
        this.programsService.getProgramStatements(this._enrollmentType).subscribe((data)=>{
          this.statements=data;
          if (data.isReferralCodeRequired){
            this.registerForm.controls["referralCode"].setValidators([Validators.required]);
          }
          else{
            this.registerForm.controls["referralCode"].setValidators([Validators.nullValidator]);
            this.registerForm.setValidators([this.referralCodeSourceSet])
          }
        });
      });

      this.programsService.getActiveProviders(this.enrollmentType).subscribe(val =>
        {
          this.activeProviders = val;
        });

      this.loginForm = fb.group({
        user: [null, Validators.required],
        password: [null, Validators.required],
        programAlias: this._enrollmentType
      });

      this.registerForm = fb.group({
        firstName: [null, [Validators.required, CustomValidators.isName()]],
        lastName: [null, [Validators.required, CustomValidators.isName()]],
        email: [null, [Validators.required, CustomValidators.isEmail()]],
        programAlias: this.enrollmentType,
        providerExists:null,
        referralCodeExists:null,
        preferredProviderId:null,
        referralCode:null
      });

      this.registerForm.get("providerExists").valueChanges.subscribe((data =>{
        // reset the fields that get hidden when providerExists changes
        if (data == "false"){
          this.registerForm.get("referralCodeExists").reset();
          this.registerForm.get("referralCode").reset();
          this.registerForm.get("preferredProviderId").reset();
        }
      }));
      
      this.registerForm.get("referralCodeExists").valueChanges.subscribe((data =>{
        // reset the field that gets hidden when referralCodeExists changes
        if (data == "true"){
          this.registerForm.get("preferredProviderId").reset();
        }
        else if (data == "false"){
          this.registerForm.get("referralCode").reset();
        }
      }));

 

  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this._enrollmentType = params['type'];
      this.programsService.getProgramStatements(this._enrollmentType).subscribe((data)=>{
        this.statements=data;
        this.registerForm.controls["referralCode"].setValidators([data.isReferralCodeRequired ?  Validators.required : Validators.nullValidator])
        this.registerForm.updateValueAndValidity();
      });
    });

  }

  protected referralCodeSourceSet(formGroup: FormGroup) {
    // Enforce a rule that the referral code question "tree" must be followed to its end, whichever one that is.
    if (formGroup.get('providerExists').value == "true"){
      if (formGroup.get('referralCode').value || formGroup.get('preferredProviderId').value){
        return null;
      }
      else{
        return {missingInput: {value: "Missing Input"}};
      }
    }
    else if (formGroup.get('providerExists').value == "false"){
      return null;
    }
    else{
      return {missingInput: {value: "Missing Input"}};
    }
  }

  protected login() {
    if (this.loginForm.valid)
      this._service.login(this.loginForm.value).subscribe(() => {
        this.router.navigate(['/stages']);
      });
  }

  protected goToForgotPassword() {
    this.router.navigate([`/security/${this._enrollmentType}/forgot-password`]);
  }

  onNameChange(e){
    e.target.value = e.target.value.trim()
  }

  protected register() {
    if (!this.registerForm.valid)
      return;
    this._service.register(this.registerForm.value).subscribe(() => {
      this.dialogSer.openDialog('Success','Registration successful, but you are not finished. Please check your e-mail for activation link.');
      this.loginForm.get('user').setValue(this.registerForm.get('email').value);
      this.registerForm.reset({programAlias: this.enrollmentType});
      this.selectedTab = LoginRegisterTabs.Login;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/security/security/login-and-register/login-and-register.component.ts